import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { api_paths } from "../config/api.paths";
import API from "../config/axios";
import { useNavigate } from "react-router-dom";
import defaultAvatar from "../assets/images/contactus/defaultavatar.png";

const base_url = "https://preview.gujaratisamajtampabay.com:3071";
const LIMIT = 5;

function Committee() {
  const [committeeMembers, setCommitteeMembers] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const navigate = useNavigate();

  // Fetch Members
  const fetchCommitteeMembers = async (pageNumber = 1) => {
    try {
      const response = await API.get(api_paths.committee.GET_COMMITTEE_MEMBER, {
        params: { page: pageNumber, limit: LIMIT },
      });

      const { data, meta } = response?.data?.payload?.result || {};

      setPage(Number(meta?.current_page));
      setTotalPage(Number(meta?.total_pages));

      if (pageNumber === 1) {
        setCommitteeMembers(data); // first load
      } else {
        setCommitteeMembers((prev) => [...prev, ...data]);
      }
    } catch (error) {
      console.error("Error fetching members:", error);
    }
  };

  // First load
  useEffect(() => {
    fetchCommitteeMembers(1);
  }, []);

  // Handle View More
  const handleViewMore = () => {
    if (page < totalPage) {
      fetchCommitteeMembers(page + 1);
    }
  };

  return (
    <div style={{ background: "#FFFFFF", padding: "50px 0" }}>
      <Container>
        {/* Heading */}
        <div className="text-center mb-4">
          <h2 className="fw-bold">Meet the Team</h2>
          <p className="text-muted">
            Our dedicated committee members work tirelessly to bring our
            community together through cultural events and programs
          </p>
        </div>

        {/* Team Grid */}
        <Row className="justify-content-center">
          {committeeMembers.map((member) => (
            <Col
              key={member._id}
              md={2}
              sm={6}
              xs={6}
              className="d-flex justify-content-center mb-4"
            >
              <div
                style={{
                  width: "140px",
                  textAlign: "center",
                  background: "#fff",
                  borderRadius: "12px",
                }}
                onClick={() => {
                  navigate(`/committee-detail/${member._id}`);
                }}
              >
                <img
                  src={
                    member.picture_path
                      ? `${base_url}${member.picture_path}`
                      : defaultAvatar
                  }
                  alt={member.name}
                  style={{
                    width: "100%",
                    height: "150px",
                    objectFit: "cover",
                    borderRadius: "12px",
                  }}
                />

                <div className="mt-2">
                  <h6 className="mb-0 fw-semibold" style={{ fontSize: "14px" }}>
                    {member.name}
                  </h6>
                  <small className="text-muted" style={{ fontSize: "12px" }}>
                    {member.position}
                  </small>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* Buttons */}
        <div className="text-center mt-3">
          <Button
            onClick={() => navigate("/past-president")}
            variant="dark"
            className="px-4 me-2"
          >
            View Past Presidents
          </Button>

          {/* View More only if more pages exist */}
          {page < totalPage && (
            <Button
              onClick={handleViewMore}
              className="px-4 bg-warning border-0"
              style={{ color: "#FFF" }}
            >
              View More
            </Button>
          )}
        </div>
      </Container>
    </div>
  );
}

export default Committee;
